import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { Location } from '@angular/common';
import { ReportService } from '../report.service';

@Component({
  selector: 'app-report-exam',
  templateUrl: './report-exam.component.html',
  styleUrls: ['./report-exam.component.scss']
})
export class ReportExamComponent implements OnInit {

  ExamRep: FormGroup;
  dialogRef: MatDialogRef<any>;
  resultyp = false;
  Exam = true;
  Branch = false;
  FrLedger = false;
  CenterCollege = false;
  Clg = false;
  center = false;
  ZnTwn = false;
  RollNo = false;
  Centre = false;
  Dist = false;
  Paper = false;
  Sheet = false;
  UniClg = false;
  Flag = false;
  SoftCp = false;
  Remark = false;
  File = false;
  Subs = false;
  BR2 = false;
  BR1 = false;
  DS1 = false;
  DS2 = false;
  APIService: any;
  filteredDataList: any;
  DataList: any;
  RGInCode = 0;
  G_Regn_Roll = '';
  FlagLabel = '';
  UniColg = 'U';
  StrVldUC = 'UC';
  TitleOne = 'titleOne';
  RollRegn = '';
  TnDist = '';
  ZoneTown = '';
  CourseList: any;
  filteredListCourse: any;
  BranchList: any;
  filteredListBranch: any;
  code: any;
  Arr: any;
  data: any;
  status: any;
  ExamList: any;
  filteredListExam: any;
  DistList: any;
  filteredListDist: any;
  StrFlagVld: string;
  StrFlgDef: string;
  PaperList: any;
  filteredListPaper: any;
  strProc: string;
  BrList: any;
  filteredListBr: any;
  RptTime: any;
  DistrictList: any;
  filteredListDistrict: any;
  submitpayload: any;
  RptName: string;
  spName: any;
  filteredListCollege: any;
  collegeList: any;
  rptCode: any;
  SessionNo: any;
  SessionNo1: any;
  RollNoPay: number = 0;
  RgNoPay: any = '';
  CenterExamCollege = false;
  examList: any;
  UserCollege: any;
  userPermission: any;
  isCollegeUser: boolean = false;

  // New properties for Session dropdown (only for RGInCode == 5 and RGInCode == 18)
  sessionList: any[] = [];
  filteredSessionList: any[] = [];

  // CHANGED: helper flag used by the template to show/hide the Session dropdown
  showSessionDropdown: boolean = false;

  // NEW: properties for course-wise marksheet template (RptCode 18)
  selectedCourseCode: string = '';
  selectedTemplateName: string = '';

  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private location: Location,
    private modalPopupService: ModalpopService, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private dialog: MatDialog,
    public fb: FormBuilder, private reportService: ReportService) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    // Check if user is a college user
    if (this.userPermission && this.userPermission.length > 0 && this.userPermission[0].CgUi == 'C') {
      this.isCollegeUser = true;
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.isCollegeUser = false;
      this.UserCollege = '';
    }

    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      // this.fetchSecretData();
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo'];
        this.route.queryParams.subscribe((params) => {
          this.RGInCode = params['MenuCode'];
          this.resetValues();
          // this.loadpage(this.RGInCode);
          this.Exam = true;
          this.Branch = false;
          this.FrLedger = false;
          this.CenterCollege = false;
          this.Clg = false;
          this.ZnTwn = false;
          this.RollNo = false;
          this.Centre = false;
          this.Dist = false;
          this.Paper = false;
          this.Sheet = false;
          this.UniClg = false;
          this.Flag = false;
          this.SoftCp = false;
          this.Remark = false;
          this.File = false;
          this.Subs = false;
          this.BR2 = false;
          this.BR1 = true;
          this.DS1 = false;
          this.DS2 = true;
          this.ExamRep = this.fb.group({
            Exam: new FormControl('', Validators.required),
            Branch: new FormControl(''),
            Ledger: new FormControl('S'),
            College: new FormControl(''),
            RollNo: new FormControl(''),
            Centre: new FormControl(''),
            District: new FormControl(''),
            Paper: new FormControl(''),
            SheetNo: new FormControl(''),
            UniClg: new FormControl(''),
            Flag: new FormControl(''),
            SoftCp: new FormControl(''),
            Remark: new FormControl(''),
            CsvFile: new FormControl(''),
            Subject: new FormControl(''),
            ZnTn: new FormControl(''),
            ResultType: new FormControl(''),
            CenterCollege: new FormControl(''),
            Course: new FormControl(''), // NEW: used only for RptCode 18 (marksheet course-wise template)
            radio: new FormControl(this.isCollegeUser ? 'clg' : ''),
          });

          // If Admit Card (RGInCode == 5) OR Result (RGInCode == 18), add Session control
          // CHANGED: added RGInCode == 18
          if (this.RGInCode == 5 || this.RGInCode == 18) {
            this.showSessionDropdown = true;
            this.ExamRep.addControl('Session', new FormControl('', Validators.required));
            this.fetchSessionList(); // load sessions
          }

          // Load report details but skip fetching exams for RGInCode == 5 / 18
          // (exams are fetched after session selection)
          // CHANGED: added RGInCode == 18
          const skipExamFetch = (this.RGInCode == 5 || this.RGInCode == 18);
          this.repDetails(this.RGInCode, this.SessionNo, skipExamFetch);
          this.fetchCourse();
        });
      });
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.route.queryParams.subscribe((params) => {
        this.RGInCode = params['MenuCode'];
        this.resetValues();
        // this.loadpage(this.RGInCode);
        this.Exam = true;
        this.Branch = false;
        this.FrLedger = false;
        this.CenterCollege = false;
        this.Clg = false;
        this.ZnTwn = false;
        this.RollNo = false;
        this.Centre = false;
        this.Dist = false;
        this.Paper = false;
        this.Sheet = false;
        this.UniClg = false;
        this.Flag = false;
        this.SoftCp = false;
        this.Remark = false;
        this.File = false;
        this.Subs = false;
        this.BR2 = false;
        this.BR1 = true;
        this.DS1 = false;
        this.DS2 = true;
        this.ExamRep = this.fb.group({
          Exam: new FormControl('', Validators.required),
          Branch: new FormControl(''),
          Ledger: new FormControl('S'),
          College: new FormControl(''),
          RollNo: new FormControl(''),
          Centre: new FormControl(''),
          District: new FormControl(''),
          Paper: new FormControl(''),
          SheetNo: new FormControl(''),
          UniClg: new FormControl(''),
          Flag: new FormControl(''),
          SoftCp: new FormControl(''),
          Remark: new FormControl(''),
          CsvFile: new FormControl(''),
          Subject: new FormControl(''),
          ZnTn: new FormControl(''),
          ResultType: new FormControl(''),
          CenterCollege: new FormControl(''),
          Course: new FormControl(''), // NEW: used only for RptCode 18 (marksheet course-wise template)
          radio: new FormControl(this.isCollegeUser ? 'clg' : ''),
        });

        // CHANGED: added RGInCode == 18
        if (this.RGInCode == 5 || this.RGInCode == 18) {
          this.showSessionDropdown = true;
          this.ExamRep.addControl('Session', new FormControl('', Validators.required));
          this.fetchSessionList();
        }

        // CHANGED: added RGInCode == 18
        const skipExamFetch = (this.RGInCode == 5 || this.RGInCode == 18);
        this.repDetails(this.RGInCode, this.SessionNo, skipExamFetch);
        this.fetchCourse();
        // this.getCollegeData();
      });
    }
  }

  // fetchSecretData() {
  //   this.umsService.getSecretData().subscribe((res) => {
  //     this.SessionNo = res.projectPharam['SnNo']
  //     }
  //   );

  // }

  resetValues() {

  }

  fetchCourse() {
    const payload = {};

    payload['LoginId'] = 0;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
    });
  }



  repDetails(id, SessionNo, skipExamFetch = false) {
    const payload = {};
    payload['RptTime'] = '';
    payload['RptCode'] = id;
    this.umsService.reportDetails(payload).subscribe(res => {
      if (res.status) {
        this.data = res.data[0];
        this.TitleOne = this.data['RptName'];
        this.RptTime = this.data['RptTime'];
        this.rptCode = this.data['RptCode'];
        this.spName = this.data['RptProc'];
        if (this.data['RptTime'] == 'O') {
          this.status = 'OARU';
        }
        else if (this.data['RptTime'] == 'A') {
          this.status = 'ARU';
        }
        else if (this.data['RptTime'] == 'R') {
          this.status = 'RU';
        }
        else {
          this.status = '';
        }

        this.loadpage(this.data['RptCode'], this.data['RptParam']);

        if (!skipExamFetch) {
          this.fetchExam(this.status, SessionNo);
        }
      }
    });
  }

  // New method: fetch active sessions
  fetchSessionList() {
    this.spinner.show();
    const payload = { SnActive: 'Y' };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data || [];
          this.filteredSessionList = [...this.sessionList];

        } else {
          this.sessionList = [];
          this.filteredSessionList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.filteredSessionList = [];
        let data = {
          message: error.error?.message || 'Failed to fetch sessions.',
          title: 'Error',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  // Handler for session change
  onSessionChange(sessionId: any) {
    this.SessionNo = sessionId;

    // Make sure the form control stays in sync (works for both 5 and 18)
    if (this.ExamRep && this.ExamRep.controls['Session']) {
      this.ExamRep.controls['Session'].setValue(sessionId);
    }

    // Reset dependent fields and lists
    this.ExamRep.patchValue({
      Exam: '',
      Branch: '',
      Paper: '',
      District: '',
      College: '',
      Course: '' // NEW: reset course on session change
    });
    this.ExamList = [];
    this.filteredListExam = [];
    this.BranchList = [];
    this.filteredListBranch = [];
    this.PaperList = [];
    this.filteredListPaper = [];
    this.collegeList = [];
    this.filteredListCollege = [];
    this.BrList = [];
    this.filteredListBr = [];
    this.DistList = [];
    this.filteredListDist = [];
    this.DistrictList = [];
    this.filteredListDistrict = [];

    // NEW: reset course-wise template state (RptCode 18)
    this.selectedCourseCode = '';
    this.selectedTemplateName = '';

    // CHANGED: for RptCode 18, re-evaluate the report flags from loadpage
    // (loadpage only depends on rptCode / rptParam, calling it again is harmless
    //  and keeps BR1/BR2/DS1/DS2 in the right state after the reset above)
    if (this.rptCode == 18 || this.rptCode == 5) {
      if (this.data && this.data['RptCode'] != null) {
        this.loadpage(this.data['RptCode'], this.data['RptParam']);
      }
    }

    // Fetch exams for the new session
    if (this.status) {
      this.fetchExam(this.status, this.SessionNo);
    }
  }

  // NEW: handle manual course selection (RptCode 18 - marksheet)
  onCourseChange(event: any) {
    this.selectedCourseCode = (event && event.value) ? event.value : '';
    this.selectedTemplateName = this.resolveMarksheetTemplate(this.selectedCourseCode);
  }

  // NEW: map course code -> HBS template name for marksheet (RptCode 18/19/20)
  // Add/edit cases here for each course that needs a different layout.
  resolveMarksheetTemplate(coCode: string): string {
    const c = (coCode || '').toString().trim().toUpperCase();
    switch (c) {
      case '10MBBS2021':        return 'Marksheet_MBBS_2021.hbs';        // RptCode 18
      case '12BNYS2024':  return 'Marksheet_BNYS_2024.hbs';        // RptCode 19
      default:            return 'Marksheet_MBBS_2021.hbs';     // RptCode 20
    }
  }

  // NEW: map selected course -> report/SP code for marksheet
  // P101        -> 18
  // 12BNYS2024  -> 19
  // everything  -> 20 (default marksheet)
  resolveRptCodeByCourse(coCode: string): number {
    const c = (coCode || '').toString().trim().toUpperCase();
    switch (c) {
      case '10MBBS2021':        return 18;
      case '12BNYS2024':  return 181;
      default:            return 18;
    }
  }

  loadpage(rptCode, rptParam) {
    // rptCode == 20 ||  no need UMS as per EDPS
    if (rptCode == 18) {
      this.resultyp = true
    }
    else {
      this.resultyp = false
    }
    if (rptCode == 5) {
      this.Branch = true;
      // Set BR2 to true to populate branch from exam streams
      this.BR1 = false;
      this.BR2 = true;
    }
    // this.ExamRep.controls['Centre'].setValue(1);
    let params = []
    params = rptParam.split(',')
    params.forEach(element => {
      switch (element) {
        case "CgCode":
          this.Clg = true;
          break;
        case "RollNo":
          this.RollNo = true;
          if (this.umsService.secretdata['RegnRoll'] == 'R') {
            this.RollRegn = 'Roll No'
          }
          else {
            this.RollRegn = 'PRN No'
          }
          break;
        case "Subs":
          this.Subs = true;
          break;
        case "Cent":
          this.Centre = true;
          break;
        case "HOM":
          this.Paper = true;
          break;
        case "CsNo":
          this.Sheet = true;
          break;
        case "UC":
          this.UniClg = true;
          break;
        case "BR":
          this.Branch = true;
          break;
        case "File":
          this.File = false;  //as it is not needed now told by shailesh sir 
          break;
        case "Ds":
          this.Dist = true;
          this.TnDist = 'District'
          break;
        case "Zone":
          this.ZnTwn = true;
          this.ZoneTown = 'Zone'
          break;
        case "TnCode":
          this.ZnTwn = true;
          this.ZoneTown = 'Town'
          break;

      }

      let code = 0;
      code = rptCode;
      if (code == 17 || code == 31) {
        this.FrLedger = true;
        this.CenterCollege = true;
        if (this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['CBCS'] != '') {
          this.FrLedger = false;
          this.ExamRep.controls['Ledger'].setValue('1');
        }
      }
      if ((code == 18 || code == 5) && (this.umsService.secretdata['ClubPartTrans'] == 11)) {
        this.Remark = true;
      }
      switch (code) {
        case 4:
          this.Flag = true;
          this.FlagLabel = 'S-With Subjects';
          this.StrFlagVld = "S";
          this.StrFlgDef = "";
          break;
        case 8:
          this.Flag = true;
          this.FlagLabel = 'S-With Subjects';
          this.StrFlagVld = "S";
          this.StrFlgDef = "";
          break;
        case 6:
          this.Flag = true;
          this.FlagLabel = 'E-Exam C-Course';
          this.StrFlagVld = "EC";
          this.StrFlgDef = "E";
          break;
        case 16:
          this.Flag = true;
          this.FlagLabel = 'E-Exam C-Course';
          this.StrFlagVld = "EC";
          this.StrFlgDef = "E";
          break;
        case 17:
          if (element == 'Flag') {
            this.Flag = true;
            if (this.umsService.secretdata['ClubPartTrans'] == 12) {
              this.FlagLabel = 'E-Edit List';
              this.StrFlagVld = "E";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 6) {
              this.FlagLabel = 'N-NRI Ledger';
              this.StrFlagVld = "N";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 13) {
              this.FlagLabel = 'R-Reval, C-Changes E-Excp';
              this.StrFlagVld = "RCE";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 14 || this.umsService.secretdata['ClubPartTrans'] == 19) {
              this.FlagLabel = 'I-INC';
              this.StrFlagVld = "I";
              this.StrFlgDef = "";
            }
            else {
              this.FlagLabel = 'R-Reval, C-Changes';
              this.StrFlagVld = "RC";
              this.StrFlgDef = "";
            }
          }
          this.ExamRep.controls['Centre'].setValue(2);
          break;
        case 31:
          if (element == 'Flag') {
            this.Flag = true;
            if (this.umsService.secretdata['ClubPartTrans'] == 12) {
              this.FlagLabel = 'E-Edit List';
              this.StrFlagVld = "E";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 6) {
              this.FlagLabel = 'N-NRI Ledger';
              this.StrFlagVld = "N";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 13) {
              this.FlagLabel = 'R-Reval, C-Changes E-Excp';
              this.StrFlagVld = "RCE";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 14 || this.umsService.secretdata['ClubPartTrans'] == 19) {
              this.FlagLabel = 'I-INC';
              this.StrFlagVld = "I";
              this.StrFlgDef = "";
            }
            else {
              this.FlagLabel = 'R-Reval, C-Changes';
              this.StrFlagVld = "RC";
              this.StrFlgDef = "";
            }
          }
          break;
        case 18:
          this.Flag = false;
          break;
        case 28:
          if (this.umsService.secretdata['ClubPartTrans'] == 12) {
            this.Flag = true;
            this.FlagLabel = 'P-Pass Cert, R-Rank Cert, M-MCI Cert, A-Attemp Cert, C-Conv Cert';
            this.StrFlagVld = "PRMAC";
            this.StrFlgDef = "P";
          }
          break;
        case 37:
          if (this.umsService.secretdata['ClubPartTrans'] == 13) {
            this.Flag = true;
            this.FlagLabel = 'Code/Name?';
            this.StrFlagVld = "Y";
            this.StrFlgDef = "";
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 14 ||
            this.umsService.secretdata['ClubPartTrans'] == 19) {
            this.Flag = true;
            this.FlagLabel = 'Int/Code/Roll?';
            this.StrFlagVld = "ICR";
            this.StrFlgDef = "I";
          }

          if (this.umsService.secretdata['ClubPartTrans'] == 9) {
            this.StrVldUC = 'TPI';
            this.UniColg = 'T/P/I';
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UCP';
            this.UniColg = 'U/C/P';
            this.SoftCp = true;
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 17) {
            this.StrVldUC = 'UCP';
            this.UniColg = 'U/C/P';
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 14 ||
            this.umsService.secretdata['ClubPartTrans'] == 19 || this.umsService.secretdata['ClubPartTrans'] == 6) {
            this.ExamRep.controls['UniClg'].setValue('C');
          }
          break;
        case 54:
          if (this.umsService.secretdata['ClubPartTrans'] == 15) {
            this.Flag = true;
            this.FlagLabel = 'Zero/All';
            this.StrFlagVld = "Z/A";
            this.StrFlgDef = "A";
          }
          break;
        case 61:
          if (this.umsService.secretdata['ClubPartTrans'] == 17) {
            this.Flag = true;
            this.FlagLabel = 'After Gracing Y/N';
            this.StrFlagVld = "N/Y";
            this.StrFlgDef = "N";
          }
          break;
        case 63:
          if (this.umsService.secretdata['ClubPartTrans'] == 17) {
            this.Flag = true;
            this.FlagLabel = 'L-List';
            this.StrFlagVld = "L/ ";
            this.StrFlgDef = "";
          }
          break;
        case 9:
          if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UP';
            this.UniColg = 'U/P';
          }
          break;
        case 22:
          if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UP';
            this.UniColg = 'U/P';
          }
          break;
        case 23:
          if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UP';
            this.UniColg = 'U/P';
          }
          break;

      }
      this.ExamRep.controls['UniClg'].setValue(this.StrVldUC[0]);

    });
  }

  fetchExam(StrStat, SessionNo) {
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = SessionNo;
    payload['ShStatus'] = StrStat;
    this.umsService.ReportExm(payload).subscribe(res => {
      if (res.status) {
        this.ExamList = res.data;
        this.filteredListExam = this.ExamList.slice();
      }
    });
  }

  getExmData(exm) {
    this.BR2 = false;
    this.BR1 = true;
    this.DS1 = false;
    this.DS2 = true;

    // NEW: for RptCode 18 (marksheet), capture course from the selected exam
    // so the correct course-wise template can be picked at print time.
    if (this.rptCode == 18) {
      const examCourse = exm.CoCode || exm.CourseCode || exm.EmCoCode || '';
      if (examCourse) {
        this.selectedCourseCode = examCourse;
        this.selectedTemplateName = this.resolveMarksheetTemplate(examCourse);
        if (this.ExamRep && this.ExamRep.controls['Course']) {
          this.ExamRep.controls['Course'].setValue(examCourse);
        }
      }
    }

    let UC = this.ExamRep.controls['UniClg'].value;
    this.fetchPaper(exm.ShId, UC);
    if (this.rptCode == 5) {
      const payload = {};
      payload['CoCode'] = '';
      payload['EmId'] = exm.ShEmId;
      this.umsService.getExamStream(payload).subscribe(res => {
        if (res.status) {
          this.BR1 = false;
          this.BR2 = true;
          this.BrList = res.data;
          this.filteredListBr = this.BrList.slice();
        } else {
          this.BrList = [];
        }
      });
    }
    else if (this.status[0] == 'R' && exm.SsShId != 0 && this.umsService.secretdata['ResParam'] == 'D') {
      const payload = {};
      payload['ShId'] = exm.ShId;
      payload['SsProc'] = 'R';
      this.umsService.SearchSTR(payload).subscribe(res => {
        this.BR1 = true;
        this.BR2 = false;
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
        if (exm.ShStatus == 'A') {
          this.strProc = 'B'
        } else {
          this.BranchList = [];
        }
      });
    } else {
      const payload = {};
      payload['CoCode'] = '';
      payload['EmId'] = exm.ShEmId;
      this.umsService.getExamStream(payload).subscribe(res => {
        if (res.status) {
          this.BR1 = false;
          this.BR2 = true;
          this.BrList = res.data;
          this.filteredListBr = this.BrList.slice();
        } else {
          this.BrList = [];
        }
      });
    }
    if (this.status[0] == 'R' && exm.SsShId != 0 && this.umsService.secretdata['ResParam'] == 'D') {
      const payload = {};
      payload['ShId'] = exm.ShId;
      payload['SsProc'] = 'R';
      this.umsService.SearchSTR(payload).subscribe(res => {
        this.BR1 = true;
        this.BR2 = false;
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
        if (exm.ShStatus == 'A') {
          this.strProc = 'B'
        }
        else {
          this.BranchList = [];
        }
      });
    }
    else {
      const payload = {};
      payload['CoCode'] = '';
      payload['EmId'] = exm.ShEmId;
      this.umsService.getExamStream(payload).subscribe(res => {
        if (res.status) {
          this.BR1 = false;
          this.BR2 = true;
          this.BrList = res.data;
          this.filteredListBr = this.BrList.slice();
        }
        else {
          this.BrList = [];
        }
      });
    }

    if (this.RptTime == 'R' && exm.SsShId != 0 && this.umsService.secretdata['ResParam'] == 'D') {
      const payload = {};
      payload['ShId'] = exm.ShId;
      payload['SsProc'] = 'R';
      this.umsService.SearchSTR(payload).subscribe(res => {
        this.DS1 = true;
        this.DS2 = false;
        this.DistrictList = res.data;
        this.filteredListDistrict = this.DistrictList.slice();
        if (exm.ShStatus == 'A') {
          this.strProc = 'D'
        }
        else {
          this.DistrictList = [];
        }
      });
    }
    else {
      const payload = {};
      this.umsService.getDistrict(payload).subscribe(res => {
        if (res.status) {
          this.DS1 = false;
          this.DS2 = true;
          this.DistList = res.data;
          this.filteredListDist = this.DistList.slice();
        }
      });
    }

  }

  fetchPaper(ShId, ColUni) {
    this.spinner.show();
    const payload = {};
    payload['ShId'] = ShId;
    payload['EmId'] = 0;
    payload['EsCollUni'] = ColUni;
    this.umsService.fetchHOM(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.PaperList = res.data;
        this.filteredListPaper = this.PaperList.slice();

      }
      else {
        this.spinner.hide();
      }
    });
  }

  getCollegeData(item) {
    if (this.rptCode == 5) {
      this.CenterExamCollege = true;
      this.examList = item
      // For admit card (RptCode 5), auto-select college if college user
      if (this.isCollegeUser && this.userPermission && this.userPermission[0].CgUi == 'C') {
        this.ExamRep.controls['College'].setValue(this.userPermission[0].CgId);
        // Auto-select Study Center radio button only for college users
        this.ExamRep.controls['radio'].setValue('clg');
        // Call studyCenter to load the college list
        this.studyCenter();
      }
    }
    else {
      this.spinner.show();
      const payload = {};
      // this.umsService.getCollege(payload).subscribe((res) => {
      //   this.spinner.hide();
      //   this.collegeList = res.data;
      //   this.filteredListCollege = this.collegeList.slice();
      // })
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
      }
      else {
        this.UserCollege = '';
      }
      payload['EmId'] = item.ShEmId;
      payload['CgCode'] = this.UserCollege;
      this.umsService.getExamCollegeForReport(payload).subscribe((res) => {
        this.spinner.hide();
        this.collegeList = res.data;
        this.filteredListCollege = this.collegeList.slice();
      })
    }


  }

  studyCenter() {
    this.Clg = true;
    this.center = false;
    this.spinner.show();
    const payload = {};
    // this.umsService.getCollege(payload).subscribe((res) => {
    //   this.spinner.hide();
    //   this.collegeList = res.data;
    //   this.filteredListCollege = this.collegeList.slice();
    // })
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    payload['EmId'] = this.examList.ShEmId;
    payload['CgCode'] = this.UserCollege;
    this.umsService.getExamCollegeForReport(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredListCollege = this.collegeList.slice();
      // If college user, auto-select the college after loading
      if (this.isCollegeUser && this.userPermission && this.userPermission[0].CgUi == 'C') {
        this.ExamRep.controls['College'].setValue(this.userPermission[0].CgId);
      }
    })
  }

  examCenter() {
    this.Clg = false;
    this.center = true;
    this.spinner.show();
    const payload = {};
    payload['ShId'] = this.examList.ShId;
    payload['EmId'] = this.examList.ShEmId;
    this.umsService.getCenterCollegeForReport(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredListCollege = this.collegeList.slice();
    })
  }

  //  Print() {
  //    if(this.userPermission[0].CgUi == 'C'){
  //     this.UserCollege= this.userPermission[0].CgId;
  //   }
  //   else{
  //     this.UserCollege = ''
  //   }
  //   if (this.ExamRep.invalid) {
  //     this.ExamRep.get('Exam').markAsTouched();
  //   }
  //   else {
  //     this.submitpayload = this.ExamRep.value;
  //     var filter: any;
  //     let payload1 = {}
  //     payload1['ResultType'] = this.ExamRep.value.ResultType;
  //     payload1['CenterCollege'] = this.ExamRep.value.CenterCollege;
  //     let jsonString = JSON.stringify(payload1);
  //     if (this.RollRegn == 'Roll No') {
  //      this.RollNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
  //      this.RgNoPay = '';
  //     }
  //     else if(this.RollRegn == 'Regn No'){
  //      this.RollNoPay = 0;
  //      this.RgNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
  //     }
  //     filter = {
  //       "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
  //       "RptCode": this.rptCode,
  //       "InstName": '',
  //       "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
  //       "ShId": this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '',
  //       "CgCode": this.submitpayload['College'] ? this.submitpayload['College'] : '',
  //       "RollNo": this.RollNoPay,
  //       "Cent": this.submitpayload['Centre'] ? this.submitpayload['Centre'] : 0,
  //       "TnCode": this.submitpayload['ZnTn'] ? this.submitpayload['ZnTn'] : 0,
  //       "EsId": this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0,
  //       "CsNo": '',
  //       "PgBreak": '',
  //       "StrId": this.submitpayload['Branch'] ? this.submitpayload['Branch'] : 0,
  //       "StrCode": '',
  //       "RgNo": this.RgNoPay,
  //       "UC": this.submitpayload['UniClg'] ? this.submitpayload['UniClg'] : 0,
  //       "Ledger": this.submitpayload['Ledger'] ? this.submitpayload['Ledger'] : 'S',
  //       "RegnRoll": this.umsService.secretdata['RegnRoll'] ? this.umsService.secretdata['RegnRoll'] : '',
  //       "DsCode": this.submitpayload['District'] ? this.submitpayload['District'] : '',
  //       "CoCode": '',
  //       "SnNo": this.SessionNo,
  //       "Extra1": jsonString,

  //     }


  //     if (filter.ShId == '' && this.umsService.secretdata['ClubPartTrans'] != 12) {
  //       let data = {};
  //       data['message'] = 'Select Exam';
  //       data['title'] = 'Information';
  //       data['icon'] = 'fas fa-box-open';
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //         AlertBoxComponent,
  //         data
  //       );
  //     }
  //     if (this.strProc == 'B' && filter.StrId == 0) {
  //       let data = {};
  //       data['message'] = 'Select Processed Branch';
  //       data['title'] = 'Information';
  //       data['icon'] = 'fas fa-box-open';
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //         AlertBoxComponent,
  //         data
  //       );
  //     }
  //     else if (this.strProc == 'D' && filter.StrId == 0) {
  //       let data = {};
  //       data['message'] = 'Select District';
  //       data['title'] = 'Information';
  //       data['icon'] = 'fas fa-box-open';
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //         AlertBoxComponent,
  //         data
  //       );
  //     }

  //     // && (this.umsService.secretdata['ClubPartTrans'] == 3 || this.umsService.secretdata['ClubPartTrans'] == 18)
  //     if (this.rptCode == 9 && (this.umsService.secretdata['ClubPartTrans'] == 3 || this.umsService.secretdata['ClubPartTrans'] == 18)) {
  //       let data = {};
  //       data['message'] = 'Select from dropdown';
  //       data['title'] = 'Information';
  //       data['icon'] = 'fas fa-box-open';
  //       this.dialogRef = this.dialog.open(MessageBoxComponent, {
  //         disableClose: true,
  //         data,
  //       });
  //     }

  //     let strLedger = ''
  //     if (this.rptCode == 17 || this.rptCode == 31) {
  //       strLedger = filter.CentCg
  //       if (strLedger == 'S') {
  //         if (this.BrList.length > 0 && filter.StrId == 0) {
  //           let data = {};
  //           data['message'] = 'Select Branch';
  //           data['title'] = 'Information';
  //           data['icon'] = 'fas fa-box-open';
  //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //             AlertBoxComponent,
  //             data
  //           );
  //         }

  //       }
  //     }

  //     if (this.umsService.secretdata['ClubPartTrans'] == 11 && filter.Remark != '') {
  //       if (this.rptCode == 18) {
  //         this.resultyp = true;
  //         const payload = {};
  //         payload['ShId'] = '';
  //         payload['RollNo'] = '';
  //         payload['Remark'] = '';
  //         payload['Flag'] = '';
  //         this.umsService.MarkLRem(payload).subscribe(res => {

  //           if (res.status) {

  //           }
  //           else {

  //           }
  //         });
  //       }
  //       else {
  //         const payload = {};
  //         payload['ShId'] = '';
  //         payload['RollNo'] = '';
  //         payload['Remark'] = '';
  //         payload['Flag'] = '';
  //         this.umsService.AdmitRem(payload).subscribe(res => {

  //           if (res.status) {

  //           }
  //           else {

  //           }
  //         });
  //       }
  //     }


  //     var payload: any;
  //     payload = filter;


  //     this.umsService.setData(JSON.stringify(payload));
  //     this.redirect('reports')
  //   }
  // }

  Print() {
    if (this.RGInCode == 5) {
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
      } else {
        this.UserCollege = '';
      }
      if (this.ExamRep.invalid) {
        this.ExamRep.get('Exam').markAsTouched();
      } else {
        this.submitpayload = this.ExamRep.value;
        let branchValue = this.submitpayload['Branch']
          ? Number(this.submitpayload['Branch'])
          : 0;
        const selectedBranch = branchValue;

        if (this.RollRegn == 'Roll No') {
          this.RollNoPay = this.submitpayload['RollNo']
            ? this.submitpayload['RollNo']
            : 0;
          this.RgNoPay = '';
        } else if (this.RollRegn == 'PRN No') {
          this.RollNoPay = 0;
          this.RgNoPay = this.submitpayload['RollNo']
            ? this.submitpayload['RollNo']
            : '';
        }
        var filter: any;
        let payload1: any = {};

        payload1['ShId'] = this.submitpayload['Exam']
          ? this.submitpayload['Exam']
          : '';

        let collegeCode = this.submitpayload['College']
          ? this.submitpayload['College']
          : this.UserCollege;
        payload1['CgCode'] = collegeCode;
        payload1['RollNo'] = this.RollNoPay;
        payload1['Cent'] = this.submitpayload['Centre']
          ? this.submitpayload['Centre']
          : '';
        payload1['RgNo'] = this.RgNoPay;
        payload1['DsCode'] = this.submitpayload['District']
          ? this.submitpayload['District']
          : '';
        payload1['EsId'] = this.submitpayload['Paper']
          ? this.submitpayload['Paper']
          : 0;
        payload1['Inst'] = this.umsService.secretdata['ClubPartTrans']
          ? this.umsService.secretdata['ClubPartTrans']
          : 0;
        payload1['StrId'] = selectedBranch;
        let jsonString = JSON.stringify(payload1);
        // if (this.RollRegn == 'Roll No') {
        //   this.RollNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
        //   this.RgNoPay = '';
        // }
        // else if (this.RollRegn == 'Regn No') {
        //   this.RollNoPay = 0;
        //   this.RgNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
        // }
        filter = {
          "LoginId": parseInt(sessionStorage.getItem('userId'))
            ? parseInt(sessionStorage.getItem('userId'))
            : 0,
          "RptCode": this.rptCode,
          "InstName": '',
          "InstNo": this.umsService.secretdata['ClubPartTrans']
            ? this.umsService.secretdata['ClubPartTrans']
            : 0,
          "ShId": this.submitpayload['Exam']
            ? this.submitpayload['Exam']
            : '',
          "CgCode": collegeCode,

          "RollNo": this.RollNoPay,
          "Cent": this.submitpayload['Centre']
            ? this.submitpayload['Centre']
            : 0,
          "TnCode": this.submitpayload['ZnTn']
            ? this.submitpayload['ZnTn']
            : 0,
          "EsId": this.submitpayload['Paper']
            ? this.submitpayload['Paper']
            : 0,
          "CsNo": '',
          "PgBreak": '',
          "StrId": selectedBranch,
          "BranchId": selectedBranch,
          "StrCode": '',
          "RgNo": this.RgNoPay,
          "UC": this.submitpayload['UniClg']
            ? this.submitpayload['UniClg']
            : 0,
          "Ledger": this.submitpayload['Ledger']
            ? this.submitpayload['Ledger']
            : 'S',
          "RegnRoll": this.umsService.secretdata['RegnRoll']
            ? this.umsService.secretdata['RegnRoll']
            : '',
          "DsCode": this.submitpayload['District']
            ? this.submitpayload['District']
            : '',
          "CoCode": '',
          "SnNo": this.SessionNo,
          "Extra1": jsonString,
          "Mode": true
        };
        if (
          filter.ShId == '' &&
          this.umsService.secretdata['ClubPartTrans'] != 12
        ) {
          let data = {};
          data['message'] = 'Select Exam';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        }
        if (this.strProc == 'B' && filter.StrId == 0) {
          let data = {};
          data['message'] = 'Select Processed Branch';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        } else if (this.strProc == 'D' && filter.StrId == 0) {
          let data = {};
          data['message'] = 'Select District';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        }

        if (
          this.rptCode == 9 &&
          (
            this.umsService.secretdata['ClubPartTrans'] == 3 ||
            this.umsService.secretdata['ClubPartTrans'] == 18
          )
        ) {
          let data = {};
          data['message'] = 'Select from dropdown';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.dialog.open(
            MessageBoxComponent,
            {
              disableClose: true,
              data
            }
          );
        }

        let strLedger = '';

        if (this.rptCode == 17 || this.rptCode == 31) {
          strLedger = filter.CentCg;

          if (strLedger == 'S') {
            if (this.BrList.length > 0 && filter.StrId == 0) {
              let data = {};
              data['message'] = 'Select Branch';
              data['title'] = 'Information';
              data['icon'] = 'fas fa-box-open';
              this.dialogRef =
                this.modalPopupService.openPopup<AlertBoxComponent>(
                  AlertBoxComponent,
                  data
                );
            }
          }
        }

        if (
          this.umsService.secretdata['ClubPartTrans'] == 11 &&
          filter.Remark != ''
        ) {
          if (this.rptCode == 18) {
            this.resultyp = true;
            const payload = {};
            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';
            this.umsService.MarkLRem(payload).subscribe(res => {
              if (res.status) {
              } else {
              }
            });
          } else {
            const payload = {};
            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';
            this.umsService.AdmitRem(payload).subscribe(res => {
              if (res.status) {
              } else {
              }
            });
          }
        }

        var payload: any = filter;

        // this.umsService.setData(JSON.stringify(payload));
        // this.redirect('hbsreports');
        this.reportService.generateHbsReport(payload);
      }
    } else {
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
      } else {
        this.UserCollege = '';
      }
      if (this.ExamRep.invalid) {
        this.ExamRep.get('Exam').markAsTouched();
      } else {
        this.submitpayload = this.ExamRep.value;
        var filter: any;

        // NEW: course-wise report code routing for marksheet (RptCode 18 only)
        // MBBS       -> 18
        // 12BNYS2024 -> 19
        // others     -> 20 (default marksheet)
        // For every other report (5, 9, 17, 31, ...) this stays equal to this.rptCode
        // so nothing else is affected.
        const courseForRpt = this.submitpayload['Course']
          ? this.submitpayload['Course']
          : this.selectedCourseCode;
        const effectiveRptCode = (this.rptCode == 18)
          ? this.resolveRptCodeByCourse(courseForRpt)
          : this.rptCode;

        if (this.RollRegn == 'Roll No') {
          this.RollNoPay = this.submitpayload['RollNo']
            ? this.submitpayload['RollNo']
            : 0;
          this.RgNoPay = '';
        } else if (this.RollRegn == 'PRN No') {
          this.RollNoPay = 0;
          this.RgNoPay = this.submitpayload['RollNo']
            ? this.submitpayload['RollNo']
            : 0;
        }
        let payload1: any = {};

        // 18 and 19 are both marksheet-style SPs with the same parameter shape.
        if (effectiveRptCode == 18 || effectiveRptCode == 181) {

          payload1['LoginId'] =
            parseInt(sessionStorage.getItem('userId'))
              ? parseInt(sessionStorage.getItem('userId'))
              : 0;

          payload1['ShId'] =
            this.submitpayload['Exam']
              ? Number(this.submitpayload['Exam'])
              : 0;

          payload1['StrId'] =
            this.submitpayload['Branch']
              ? Number(this.submitpayload['Branch'])
              : 0;

          payload1['CgCode'] =
            this.submitpayload['College']
              ? this.submitpayload['College']
              : this.UserCollege;

          payload1['EfRollNo'] =
            this.RollNoPay
              ? Number(this.RollNoPay)
              : 0;

          payload1['RgNo'] =
            this.RgNoPay
              ? this.RgNoPay
              : '';

          payload1['Flag'] =
            this.submitpayload['Flag']
              ? this.submitpayload['Flag']
              : '';

          payload1['Inst'] =
            this.umsService.secretdata['ClubPartTrans']
              ? Number(this.umsService.secretdata['ClubPartTrans'])
              : 0;

          payload1['ResultType'] =
            this.submitpayload['ResultType']
              ? this.submitpayload['ResultType']
              : 'A';

        } else {

          // Existing functionality for other reports
          payload1['ResultType'] =
            this.ExamRep.value.ResultType;

          payload1['CenterCollege'] =
            this.ExamRep.value.CenterCollege;
        }


        // Convert parameters to JSON
        let jsonString = JSON.stringify(payload1);
        filter = {
          "LoginId":
            parseInt(sessionStorage.getItem('userId'))
              ? parseInt(sessionStorage.getItem('userId'))
              : 0,
          "RptCode": effectiveRptCode,
          "InstName": '',
          "InstNo":
            this.umsService.secretdata['ClubPartTrans']
              ? this.umsService.secretdata['ClubPartTrans']
              : 0,
          "ShId":
            this.submitpayload['Exam']
              ? this.submitpayload['Exam']
              : '',
          "CgCode":
            this.submitpayload['College']
              ? this.submitpayload['College']
              : this.UserCollege,
          "RollNo": this.RollNoPay,
          "Cent":
            this.submitpayload['Centre']
              ? this.submitpayload['Centre']
              : 0,
          "TnCode":
            this.submitpayload['ZnTn']
              ? this.submitpayload['ZnTn']
              : 0,
          "EsId":
            this.submitpayload['Paper']
              ? this.submitpayload['Paper']
              : 0,

          "CsNo": '',

          "PgBreak": '',

          "StrId":
            this.submitpayload['Branch']
              ? this.submitpayload['Branch']
              : 0,

          "StrCode": '',

          "RgNo": this.RgNoPay,

          "UC":
            this.submitpayload['UniClg']
              ? this.submitpayload['UniClg']
              : 0,

          "Ledger":
            this.submitpayload['Ledger']
              ? this.submitpayload['Ledger']
              : 'S',

          "RegnRoll":
            this.umsService.secretdata['RegnRoll']
              ? this.umsService.secretdata['RegnRoll']
              : '',

          "DsCode":
            this.submitpayload['District']
              ? this.submitpayload['District']
              : 0,

          "CoCode": (effectiveRptCode == 18 || effectiveRptCode == 181)
            ? (courseForRpt || '')
            : '',

          // NEW: template key for course-wise marksheet (RptCode 18/19/20).
          // Top-level key -> backend can read req.body.TemplateName.
          // Ignored by the SP call (like RptCode / Mode / SnNo are).
          "TemplateName": (effectiveRptCode == 18 || effectiveRptCode == 181)
            ? (this.selectedTemplateName
                || this.resolveMarksheetTemplate(courseForRpt))
            : '',

          "SnNo": this.SessionNo,
          "Extra1": jsonString,
          "Mode": true
        };

        if (
          filter.ShId == '' &&
          this.umsService.secretdata['ClubPartTrans'] != 12
        ) {

          let data = {};

          data['message'] = 'Select Exam';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';

          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        }


        if (this.strProc == 'B' && filter.StrId == 0) {

          let data = {};

          data['message'] = 'Select Processed Branch';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';

          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );

        } else if (this.strProc == 'D' && filter.StrId == 0) {

          let data = {};

          data['message'] = 'Select District';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';

          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        }

        if (
          this.rptCode == 9 &&
          (
            this.umsService.secretdata['ClubPartTrans'] == 3 ||
            this.umsService.secretdata['ClubPartTrans'] == 18
          )
        ) {

          let data = {};

          data['message'] = 'Select from dropdown';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';

          this.dialogRef = this.dialog.open(
            MessageBoxComponent,
            {
              disableClose: true,
              data
            }
          );
        }


        // Ledger validation
        let strLedger = '';

        if (this.rptCode == 17 || this.rptCode == 31) {

          strLedger = filter.CentCg;

          if (strLedger == 'S') {

            if (
              this.BrList.length > 0 &&
              filter.StrId == 0
            ) {

              let data = {};

              data['message'] = 'Select Branch';
              data['title'] = 'Information';
              data['icon'] = 'fas fa-box-open';

              this.dialogRef =
                this.modalPopupService.openPopup<AlertBoxComponent>(
                  AlertBoxComponent,
                  data
                );
            }
          }
        }

        if (
          this.umsService.secretdata['ClubPartTrans'] == 11 &&
          filter.Remark != ''
        ) {

          if (this.rptCode == 18) {

            this.resultyp = true;

            const payload: any = {};

            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';

            this.umsService.MarkLRem(payload)
              .subscribe(res => {

                if (res.status) {
                } else {
                }

              });

          } else {

            const payload: any = {};

            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';

            this.umsService.AdmitRem(payload)
              .subscribe(res => {

                if (res.status) {
                } else {
                }

              });
          }
        }

        var payload: any;

        payload = filter;

        this.umsService.setData(
          JSON.stringify(payload)
        );

        // RptCode 18 / 19 / 20 -> HBS Reports (course-wise marksheet)
        if (effectiveRptCode == 18
            || effectiveRptCode == 181
            || effectiveRptCode == 18) {

          // this.redirect('hbsreports');
          this.reportService.generateHbsReport(payload);

        } else {

          this.redirect('reports');
        }
      }
    }
  }
  onBranchSelect(event: any) {
    this.ExamRep.patchValue({ Branch: Number(event.value) });
  }
  Print1() {
    if (this.RGInCode == 5) {
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
      } else {
        this.UserCollege = ''
      }
      if (this.ExamRep.invalid) {
        this.ExamRep.get('Exam').markAsTouched();
      } else {
        this.submitpayload = this.ExamRep.value;
        let branchValue = this.submitpayload['Branch'] ? Number(this.submitpayload['Branch']) : 0;
        const selectedBranch = branchValue;

        if (this.RollRegn == 'Roll No') {
          this.RollNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
          this.RgNoPay = '';
        } else if (this.RollRegn == 'PRN No') {
          this.RollNoPay = 0;
          this.RgNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : '';
        }

        var filter: any;
        let payload1 = {}
        payload1['ShId'] = this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '';
        let collegeCode = this.submitpayload['College'] ? this.submitpayload['College'] : this.UserCollege;
        payload1['CgCode'] = collegeCode;
        payload1['RollNo'] = this.RollNoPay;
        payload1['Cent'] = this.submitpayload['Centre'] ? this.submitpayload['Centre'] : '';
        payload1['RgNo'] = this.RgNoPay;
        payload1['DsCode'] = this.submitpayload['District'] ? this.submitpayload['District'] : '';
        payload1['EsId'] = this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0;
        payload1['Inst'] = this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0;
        payload1['StrId'] = selectedBranch;
        let jsonString = JSON.stringify(payload1);

        filter = {
          "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
          "RptCode": 7,
          "InstName": '',
          "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
          "ShId": this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '',
          "CgCode": collegeCode,
          "RollNo": this.RollNoPay,
          "Cent": this.submitpayload['Centre'] ? this.submitpayload['Centre'] : 0,
          "TnCode": this.submitpayload['ZnTn'] ? this.submitpayload['ZnTn'] : 0,
          "EsId": this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0,
          "CsNo": '',
          "PgBreak": '',
          "StrId": selectedBranch,
          "BranchId": selectedBranch,
          "StrCode": '',
          "RgNo": this.RgNoPay,
          "UC": this.submitpayload['UniClg'] ? this.submitpayload['UniClg'] : 0,
          "Ledger": this.submitpayload['Ledger'] ? this.submitpayload['Ledger'] : 'S',
          "RegnRoll": this.umsService.secretdata['RegnRoll'] ? this.umsService.secretdata['RegnRoll'] : '',
          "DsCode": this.submitpayload['District'] ? this.submitpayload['District'] : '',
          "CoCode": '',
          "SnNo": this.SessionNo,
          "Extra1": jsonString,
          "Mode": true
        }

        if (filter.ShId == '' && this.umsService.secretdata['ClubPartTrans'] != 12) {
          let data = {};
          data['message'] = 'Select Exam';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
        if (this.strProc == 'B' && filter.StrId == 0) {
          let data = {};
          data['message'] = 'Select Processed Branch';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else if (this.strProc == 'D' && filter.StrId == 0) {
          let data = {};
          data['message'] = 'Select District';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }

        if (this.rptCode == 9 && (this.umsService.secretdata['ClubPartTrans'] == 3 || this.umsService.secretdata['ClubPartTrans'] == 18)) {
          let data = {};
          data['message'] = 'Select from dropdown';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.dialog.open(MessageBoxComponent, {
            disableClose: true,
            data,
          });
        }

        let strLedger = ''
        if (this.rptCode == 17 || this.rptCode == 31) {
          strLedger = filter.CentCg
          if (strLedger == 'S') {
            if (this.BrList.length > 0 && filter.StrId == 0) {
              let data = {};
              data['message'] = 'Select Branch';
              data['title'] = 'Information';
              data['icon'] = 'fas fa-box-open';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
            }
          }
        }

        if (this.umsService.secretdata['ClubPartTrans'] == 11 && filter.Remark != '') {
          if (this.rptCode == 18) {
            this.resultyp = true;
            const payload = {};
            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';
            this.umsService.MarkLRem(payload).subscribe(res => {
              if (res.status) { } else { }
            });
          } else {
            const payload = {};
            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';
            this.umsService.AdmitRem(payload).subscribe(res => {
              if (res.status) { } else { }
            });
          }
        }

        var payload: any;
        payload = filter;

        this.umsService.setData(JSON.stringify(payload));
        // this.redirect('hbsreports')
        this.reportService.generateHbsReport(payload);
      }
    }
  }
  Print2() {
    if (this.RGInCode == 5) {
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
      } else {
        this.UserCollege = ''
      }
      if (this.ExamRep.invalid) {
        this.ExamRep.get('Exam').markAsTouched();
      } else {
        this.submitpayload = this.ExamRep.value;
        let branchValue = this.submitpayload['Branch'] ? Number(this.submitpayload['Branch']) : 0;
        const selectedBranch = branchValue;

        if (this.RollRegn == 'Roll No') {
          this.RollNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
          this.RgNoPay = '';
        } else if (this.RollRegn == 'PRN No') {
          this.RollNoPay = 0;
          this.RgNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : '';
        }

        var filter: any;
        let payload1 = {}
        payload1['ShId'] = this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '';
        let collegeCode = this.submitpayload['College'] ? this.submitpayload['College'] : this.UserCollege;
        payload1['CgCode'] = collegeCode;
        payload1['RollNo'] = this.RollNoPay;
        payload1['Cent'] = this.submitpayload['Centre'] ? this.submitpayload['Centre'] : '';
        payload1['RgNo'] = this.RgNoPay;
        payload1['DsCode'] = this.submitpayload['District'] ? this.submitpayload['District'] : '';
        payload1['EsId'] = this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0;
        payload1['Inst'] = this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0;
        payload1['StrId'] = selectedBranch;
        let jsonString = JSON.stringify(payload1);

        filter = {
          "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
          "RptCode": 8,
          "InstName": '',
          "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
          "ShId": this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '',
          "CgCode": collegeCode,
          "RollNo": this.RollNoPay,
          "Cent": this.submitpayload['Centre'] ? this.submitpayload['Centre'] : 0,
          "TnCode": this.submitpayload['ZnTn'] ? this.submitpayload['ZnTn'] : 0,
          "EsId": this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0,
          "CsNo": '',
          "PgBreak": '',
          "StrId": selectedBranch,
          "BranchId": selectedBranch,
          "StrCode": '',
          "RgNo": this.RgNoPay,
          "UC": this.submitpayload['UniClg'] ? this.submitpayload['UniClg'] : 0,
          "Ledger": this.submitpayload['Ledger'] ? this.submitpayload['Ledger'] : 'S',
          "RegnRoll": this.umsService.secretdata['RegnRoll'] ? this.umsService.secretdata['RegnRoll'] : '',
          "DsCode": this.submitpayload['District'] ? this.submitpayload['District'] : '',
          "CoCode": '',
          "SnNo": this.SessionNo,
          "Extra1": jsonString,
          "Mode": true
        }

        if (filter.ShId == '' && this.umsService.secretdata['ClubPartTrans'] != 12) {
          let data = {};
          data['message'] = 'Select Exam';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
        if (this.strProc == 'B' && filter.StrId == 0) {
          let data = {};
          data['message'] = 'Select Processed Branch';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else if (this.strProc == 'D' && filter.StrId == 0) {
          let data = {};
          data['message'] = 'Select District';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }

        if (this.rptCode == 9 && (this.umsService.secretdata['ClubPartTrans'] == 3 || this.umsService.secretdata['ClubPartTrans'] == 18)) {
          let data = {};
          data['message'] = 'Select from dropdown';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-box-open';
          this.dialogRef = this.dialog.open(MessageBoxComponent, {
            disableClose: true,
            data,
          });
        }

        let strLedger = ''
        if (this.rptCode == 17 || this.rptCode == 31) {
          strLedger = filter.CentCg
          if (strLedger == 'S') {
            if (this.BrList.length > 0 && filter.StrId == 0) {
              let data = {};
              data['message'] = 'Select Branch';
              data['title'] = 'Information';
              data['icon'] = 'fas fa-box-open';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
            }
          }
        }

        if (this.umsService.secretdata['ClubPartTrans'] == 11 && filter.Remark != '') {
          if (this.rptCode == 18) {
            this.resultyp = true;
            const payload = {};
            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';
            this.umsService.MarkLRem(payload).subscribe(res => {
              if (res.status) { } else { }
            });
          } else {
            const payload = {};
            payload['ShId'] = '';
            payload['RollNo'] = '';
            payload['Remark'] = '';
            payload['Flag'] = '';
            this.umsService.AdmitRem(payload).subscribe(res => {
              if (res.status) { } else { }
            });
          }
        }

        var payload: any;
        payload = filter;

        this.umsService.setData(JSON.stringify(payload));
        // this.redirect('hbsreports')
        this.reportService.generateHbsReport(payload);
      }
    }
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }
}